// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateEmployeeDeductionResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/create_employee_deduction
 * Returns the created employee deduction (flat `employee_deductions` row).
 *
 * Source: Employee_deductions_model::get($id) → SELECT * FROM employee_deductions
 * (bare PK fetch — no items[], no employee_name/status_label/amount_remaining
 * enrichment; those are added only by the list / getWithItems paths).
 *
 * Money columns (`amount`, `amount_paid`) are MySQL DECIMAL(10,2) and surface
 * as PHP strings via mysqli — typed `string` to match runtime.
 *
 * `created_at` is converted GMT-3 → ISO 8601 UTC in the controller via
 * convert_gmt3_to_utc_batch() before the Response is built.
 *
 * dados is an object whose fields are these public typed properties (default
 * getDados() reflection), so the generated runtime schema validates each field.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreateEmployeeDeductionResponseDados {
id: number
employee_id: string
franchise_id: number
title: string
amount: string
status: number
amount_paid: string
created_at: string
created_by: string
description?: string
updated_at?: string
}

export type Payroll_CreateEmployeeDeductionResponse = ApiResponse<Payroll_CreateEmployeeDeductionResponseDados>;

registerResponseContract('Payroll_CreateEmployeeDeductionResponse', {
  id:           { type: 'number',  required: true },
  employee_id:  { type: 'string',  required: true },
  franchise_id: { type: 'number',  required: true },
  title:        { type: 'string',  required: true },
  amount:       { type: 'string',  required: true },
  status:       { type: 'number',  required: true },
  amount_paid:  { type: 'string',  required: true },
  created_at:   { type: 'string',  required: true },
  created_by:   { type: 'string',  required: true },
  description:  { type: 'string',  required: false },
  updated_at:   { type: 'string',  required: false },
})
